import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import  get  from 'lodash/get';
import { GetRequest } from '../utils/api';
import { PostRequest } from '../utils/api';
import { PutRequest } from '../utils/api';
import { UrlConstants } from '../utils/ApiConstants';
import { triggerLogout } from '../utils/utils';

export interface APIError {
  appName: string;
  code: string;
  data: any;
  message: string;
  status: number;
}
export interface RequestConfig<T> extends AxiosRequestConfig {
  data?: T;
}

const noResponseError = {
  message: 'Unexpected error occurred. Please try again.',
};

export const handleApiError = <R>(error: AxiosError): Promise<R> => {
  const apiError = get(error, 'response.data.error', noResponseError);
  if (error.code === 'ERR_NETWORK') {
    localStorage.removeItem("user");
    triggerLogout();
  }

  return Promise.reject(apiError);
};

export const request = <R>(config: any): Promise<R | APIError> => {

  //Domian is not required if call is happening from Generic API layer
  config.url = config.url.replace(UrlConstants.BASE_URL, '');

  if (config.method === "GET") {
    return GetRequest(config.url).then((res: any) => res as R).catch((error: any) => handleApiError<any>(error));
  } else if (config.method === "POST") {
    return PostRequest(config.url, config.data).then((res: any) => res as R).catch((error: any) => handleApiError<any>(error));
  } else if (config.method === "PUT") {
    return PutRequest(config.url, config.data).then((res: any) => res as R).catch((error: any) => handleApiError<any>(error));
  }

  //Domain is required if call is happening with axios directrly
  config.url = UrlConstants.BASE_URL + config.url;

  return axios.request(config).then((res: any) => res.data as R).catch((error: any) => handleApiError<any>(error));

}

